export enum Symbols {
    EM_DASH = '\u2014',
}
